import React from 'react';

// Most owners select everything the popup lists, so "Select All Above" is the main button and "Create New …" the
// secondary one. Either is left out when it has nothing to do (onSelectAll / onCreateNew null).
const AddPopupButtons = ({ onSelectAll, selectingAll, disabled, createNewLabel, onCreateNew }) => {
  if (!onSelectAll && !onCreateNew) {
    return null;
  }
  return (
    <>
      <hr />
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
        {onSelectAll && (
          <button type="button" className="dct-button dct-button--primary" onClick={onSelectAll} disabled={disabled}>
            <i className="fa fa-plus-square-o" aria-hidden="true"></i>{' '}
            {selectingAll ? t('quote_builder_widget.saving') : t('quote_builder_widget.select_all_for_widget')}
          </button>
        )}
        {onCreateNew && (
          <button type="button" className="dct-button dct-button--secondary" onClick={onCreateNew}>
            <i className="fa fa-plus" aria-hidden="true"></i>{' '}
            {createNewLabel}
          </button>
        )}
      </div>
    </>
  );
};

export default AddPopupButtons;
